import * as React from 'react';
import { Table } from 'react-bootstrap';
import { formatPhoneNumber } from 'utils';
import { IConfigContact } from '@bb/domain/dist/types';

type ContactType = IConfigContact & {
  phone: any[];
  firstName: string;
  lastName: string;
  deliveries: any;
  status?: string;
};
type ListingContactTableProp = {
  contacts: ContactType[];
  selectedId?: string;
  onSelect?: (contactId: string) => void;
};

const ListingContactTable = (props: ListingContactTableProp) => {
  const { contacts, onSelect, selectedId } = props;
  const multiConfStatusMap = new Map(
    Object.entries({
      new: 'New',
      attempted: 'Attempted',
      confirm: 'Confirmed',
      deny: 'Denied',
      cancel: 'Cancelled',
    }),
  );
  return (
    <Table condensed striped bordered className="listing-contact-table">
      <tbody>
        {contacts.map((contact, index) => {
          const { lastName, firstName, phone, deliveries, type, importance } =
            contact;
          // Only display must call numbers
          const phoneNumbers = phone
            .filter(number => number.mustCall)
            .map(chosenPhone => (
              <div key={chosenPhone.number}>
                <div className="text-danger">
                  <small>MUST CALL</small>
                </div>
                {formatPhoneNumber(chosenPhone.number)}
              </div>
            ));
          const receivingText = phone.some(p => p.sendSms);
          const receivingEmails = deliveries.Email;

          return (
            <tr
              className={
                selectedId && selectedId === contact.contactId ? 'selected' : ''
              }
              key={contact.contactId}
              onClick={() => {
                if (onSelect && ['new', 'attempted'].includes(contact.status)) {
                  onSelect(contact.contactId);
                }
              }}
              style={{
                cursor:
                  onSelect &&
                  ['new', 'attempted'].includes(contact.status) &&
                  'pointer',
              }}
            >
              <td>
                {`${firstName} ${lastName}`}
                <div>
                  <small style={{ fontSize: 10 }}>
                    {type.toUpperCase()} - {importance.toUpperCase()}
                    {contact.status && (
                      <span>
                        <br />
                        {['new', 'attempted'].includes(contact.status) && (
                          <small>
                            <strong className="text-primary-2">
                              <i className="pe-7s-attention fat"></i> Multi-conf
                            </strong>
                            <strong>
                              {' '}
                              - {multiConfStatusMap.get(contact.status)}
                            </strong>
                          </small>
                        )}
                        {contact.status === 'confirm' && (
                          <small>
                            <strong style={{ color: 'green' }}>
                              {multiConfStatusMap.get(contact.status)}
                            </strong>
                          </small>
                        )}
                      </span>
                    )}
                  </small>
                </div>
              </td>
              <td>
                {receivingEmails && (
                  <div>
                    <small style={{ color: 'green' }}>RECEIVING EMAILS</small>
                  </div>
                )}
                {receivingText && (
                  <div>
                    <small style={{ color: 'green' }}>RECEIVING TEXTS</small>
                  </div>
                )}
              </td>
              <td>{phoneNumbers}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default ListingContactTable;
